<template>
  <BbPopup v-model="confirmPopupOpened" :showCloseIcon="true" contentClass="confirm-dialog">
    <template #popup-header>
      <TextBody tag="span" :i18n-key="titleKey" :text="title" :body-type="3" weight="medium"></TextBody>
    </template>
    <TextBody tag="span" :i18n-key="warningMessageKey" :text="warningMessage" :body-type="2" weight="medium"></TextBody>
    <div v-if="warningMessageKey2 || warningMessage2">
      <br />
      <TextBody
        tag="span"
        :i18n-key="warningMessageKey2"
        :text="warningMessage2"
        :body-type="2"
        weight="medium"
      ></TextBody>
    </div>
    <template #popup-actions>
      <BbBtn type="secondary" @click="confirmPopupOpened = false">
        <TextBody i18n-key="common.cancel" />
      </BbBtn>
      <BbBtn v-if="confirmTextKey || confirmText" color="#c64444" @click="emit('execute:action')">
        <TextBody :i18n-key="confirmTextKey" :text="confirmText"></TextBody>
      </BbBtn>
    </template>
  </BbPopup>
</template>

<script>
import { computed } from 'vue';
import TextBody from '~/components/common/TextBody';

export default {
  components: { TextBody },
  props: {
    popupOpened: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    warningMessage: {
      type: String,
      default: '',
    },
    warningMessage2: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    titleKey: {
      type: String,
      default: '',
    },
    warningMessageKey: {
      type: String,
      default: '',
    },
    warningMessageKey2: {
      type: String,
      default: '',
    },
    confirmTextKey: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const confirmPopupOpened = computed({
      get: () => props.popupOpened,
      set: (val) => emit('update:open', val),
    });

    return {
      emit,
      confirmPopupOpened,
    };
  },
};
</script>
